const logger = {
  error(msg) {
    console.error(msg); // eslint-disable-line
  },
  debug(msg) {
    console.debug(msg); // eslint-disable-line
  },
};

export default logger;



// WEBPACK FOOTER //
// ./src/common/utilities/logger.js